import { formatDateAndTimeTz, userTimeZone } from '@shared/utils/date';
import { NumberValue } from '../Number';
import {
  DateRangeColumnFilter,
  dateRangeFilterFn,
} from './filter/DateRangeColumnFilter';
import { NumberColumnFilter } from './filter/NumberColumnFilter';
import type { DataType, ExtendedColumnDef, UnknownTextTree } from './types';

type DataTypeConfig = Partial<ExtendedColumnDef<any, UnknownTextTree>>;

const config: Record<DataType, DataTypeConfig> = {
  date: {
    Filter: DateRangeColumnFilter,
    filterFn: dateRangeFilterFn,
    sortingFn: 'datetime',
    sortUndefined: -1,
    meta: {
      filterLabel: (filterValue, { column }) => {
        if (!Array.isArray(filterValue)) {
          return '';
        }
        const [f, t] = filterValue;
        if (typeof f !== 'number' || typeof t !== 'number') {
          return '';
        }
        const tz = column.columnDef.meta?.timeZone ?? userTimeZone();
        return [
          formatDateAndTimeTz(new Date(f), tz),
          formatDateAndTimeTz(new Date(t), tz),
        ].join(' ... ');
      },
    },
  },
  number: {
    Filter: NumberColumnFilter,
    filterFn: 'inNumberRange',
    cell: ({ getValue, column }) => (
      <NumberValue
        value={getValue()}
        fractionDigits={column.columnDef.meta?.fractionDigits ?? 1}
      />
    ),
    sortUndefined: -1,
    meta: {
      enableAggregations: true,
    },
  },
};

export function getColumnDefaults(dataType: DataType | undefined) {
  if (dataType === undefined) {
    return null;
  }
  return config[dataType];
}
